import { render, staticRenderFns } from "./Achievements.vue?vue&type=template&id=5b601d32&scoped=true"
import script from "./Achievements.vue?vue&type=script&lang=js"
export * from "./Achievements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b601d32",
  null
  
)

export default component.exports